import * as React from 'react';
import PropTypes from 'prop-types';

import Locatable from '../classes/Locatable';
import Position from '../classes/Position';

import MapSelector from '../containers/MapSelector';
import Footbar from './Footbar';
import Map from '../containers/Map';
import PoiDetailsView from './PoiDetailsView/PoiDetailsView';

import SVGService from '../services/SVG';
import RoutingService from '../services/Routing';
import POIService from '../services/POI';
import APIService from '../services/API';
import NativeService from '../services/Native';

/**
 * A top-level component for displaying the various page layout elements and kicking off initial load
 *
 * @param {any} props
 * @returns {React.Component}
 */

const dispatchWindowEvent = (data) => {
    if (data) {
        const evt = new Event('message');
        evt.data = data;
        window.dispatchEvent(evt);
    }
}

class App extends React.Component {
    constructor (props) {
        super(props);

        // Track loading and error display state
        this.state = {
            loading: true,
            displayMock: false,
            oldStyle: true,
            showHere: false,
            showRestrooms: false,
            showElevators: false,
            showEscalators: false,
            showStairs: false,
            showEvents: false,
            showAtm: false,
            showWaypoints: false,
            showRoute: false,
            aoisL: [],
            markerVisible: false,
            debuggerMenu: false
        };

        this.testFunc = this.testFunc.bind(this);
        this.backToNormal = this.backToNormal.bind(this);
        this.removeColor = this.removeColor.bind(this);
    }

    testFunc() {
      this.setState(state => ({
        displayMock: !state.displayMock,
        oldStyle: false
      }));
    }

    toggleMarker = () => {
        this.setState({ markerVisible: !this.state.markerVisible });
    }

    backToNormal() {
      this.setState(state => ({
        oldStyle: !state.oldStyle,
        displayMock: false
      }));
    }

    removeColor() {
        //use this to remove the color on all SVGs (remove the styled color, not base CSS for SVGs) ...then if hit again maybe refill all with IDs with new Random Colors
    }

    toggleDebugger = () => {
        this.setState({ debuggerMenu: !this.state.debuggerMenu });
    }

    render () {
        const {
                setSelectedMap,
                // selectedMap,
                availableMaps,
                activeRenderer,
                renderers,
                setRenderer,
            } = this.props;

        const {
            markerVisible,
            markerPOI,
            debuggerMenu
        } = this.state;

        if (this.state.loading) {
            return (
                <section className={"hero is-black is-fullheight is-loading"} />
            );
        }

        const mapItems = availableMaps.map((availableMap) => {
            return(
              <Map mapOverride={availableMap} hidden={this.state.displayMock} retro={this.state.oldStyle} />
            );
        });

        const btnStyle = {background: 'grey', borderRadius: '100px', height: 100, width: 100, fontSize: 80, bottom: 0, marginLeft: 30, userSelect: 'none'};
        const debugMenuStyle = {background: 'grey', borderRadius: '100px', height: 100, width: 100, fontSize: 80, bottom: 0, marginBottom: 15, userSelect: 'none'};

        return (
            <div>
              <section className={"hero is-black is-fullheight"}>
                  {/* <div className="hero-head">
                      <MapSelector />
                  </div> */}

                  { this.getErrorComponent() }

                  <div className="hero-foot">
                      {/* TODO: Make this more generic - should have container applying props rather than passing through App */}
                      <Footbar
                          activeRenderer = {activeRenderer}
                          renderers = {renderers}
                          setRenderer = {setRenderer}
                      />
                  </div>
              </section>
              { mapItems }

              {markerVisible && <div style={{position: 'absolute', width: '100%', height: '100%', top: '0', zIndex: 1}}>
                <PoiDetailsView poiData={{name: 'NAME', description: 'DESC', media: [], categories: []}}
                                markerPOI={markerPOI} />
              </div>}
              {/* <div style={{height: 200, width: '100%', position: "absolute", bottom: 50, zIndex: 200 }} >
                  <div style={{position: 'absolute', bottom: 0, textAlign: 'center', width: '100%'}}>
                    <button style={btnStyle} onClick={() => this.testFunc()}>&#8617;</button>
                    <button style={btnStyle} onClick={() => this.backToNormal()}>&darr;</button>
                    <button style={btnStyle} onClick={() => this.toggleDebugger()}>&#8620;</button>
                    <button onClick={this.toggleMarker} style={btnStyle}>&#8620;</button>
                  </div>
              </div> */}

              {debuggerMenu && <div style={{height: '100%', width: '100px', position: "absolute", right: 50, bottom: 0, zIndex: 2 }} >
                  <div style={{ position: 'relative', top: '50%', transform: 'translateY(-50%)' }}>
                    <button style={debugMenuStyle} onClick={() => dispatchWindowEvent('CmdZoomIn')}>🗺</button>
                    <button style={debugMenuStyle} onClick={() => dispatchWindowEvent('CmdZoomOut')}>📍</button>
                    <button style={debugMenuStyle} onClick={() => dispatchWindowEvent('CmdElevators')}>^</button>
                    <button style={debugMenuStyle} onClick={() => dispatchWindowEvent('CmdEscalators')}>_-/</button>
                    <button style={debugMenuStyle} onClick={() => dispatchWindowEvent('CmdStairs')}>_-|</button>
                    <button style={debugMenuStyle} onClick={() => dispatchWindowEvent('CmdAtm')}>|$|</button>
                    <button style={debugMenuStyle} onClick={() => dispatchWindowEvent('CmdRestrooms')}>🚻</button>
                    <button style={debugMenuStyle} onClick={() => dispatchWindowEvent('CmdYouAreHere')}>✅</button>
                    <button style={debugMenuStyle} onClick={() => dispatchWindowEvent('CmdEventsList')}>🗓</button>
                  </div>
              </div>}
            </div>
        );
    }

    toggleYou() {
        console.log("Show You Are Here");
        this.setState( {showHere: !this.state.showHere } );


        if ( this.state.showHere ) {
          this.props.availableMaps.forEach( map => {
              if (map.level == 1) {
                this.props.setSelectedMap(map);
              }
          } );

          var ggroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
          ggroup.setAttribute('id', 'youarehereg');
          //ggroup.setAttributeNS(null, 'style', 'fill: #558DCA; stroke: #FFFFFF; stroke-width: 2px;' );
          ggroup.setAttributeNS(null, 'transform', "translate(" + (300) + " " + (400) + ")");

          var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
          circle.setAttribute('id', 'youarehere');
          // circle.setAttributeNS(null, 'cx', 300);
          // circle.setAttributeNS(null, 'cy', 400);
          circle.setAttributeNS(null, 'r', 5);
          circle.setAttributeNS(null, 'style', 'fill: #558DCA; stroke: #FFFFFF; stroke-width: 2px;' );

          var yah = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
          yah.setAttributeNS(null, 'gradientUnits', "userSpaceOnUse");
          yah.setAttributeNS(null, 'id',"SVGID_1_");
          yah.setAttributeNS(null, 'x1', "94.1139");
          yah.setAttributeNS(null, 'y1', "326.6606");
          yah.setAttributeNS(null, 'x2', "536.7292");
          yah.setAttributeNS(null, 'y2', "326.6606");
          yah.setAttributeNS(null, 'gradientTransform', "matrix(6.123234e-17 -1 1 6.123234e-17 -8.9488 642.2184)");

          var stop1 = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
          var stop2 = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
          stop1.setAttributeNS(null, 'offset', "0");
          stop1.setAttributeNS(null, 'style', "stop-color:#2484C6;stop-opacity:0.5");
          stop2.setAttributeNS(null, 'offset', "1");
          stop2.setAttributeNS(null, 'style', "stop-color:#2484C6;stop-opacity:0");
          yah.appendChild(stop1);
          yah.appendChild(stop2);

          var facing = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
          facing.setAttribute('id', 'facing');
          facing.setAttributeNS(null, 'points', "461.3,78.4 358.5,508.1 324,540.7 279.9,507.6 174.1,78.4 ");
          facing.setAttributeNS(null, 'style', 'fill:url(#SVGID_1_)');
          var node = facing.getBBox();
          facing.setAttributeNS(null, 'transform', "translate(" + (-47) + " " + (-77) + ") scale(0.15 0.15)");

          const mapName = "AmericanDream.Floor1";
          // const mapName = that.props.availableMaps[0].structure + '.Floor' + that.props.availableMaps[0].level
          const mapSVG = document.getElementById(mapName);
          if (mapSVG) {
           const drawTarget = mapSVG.getElementById("Impossible");
           drawTarget.appendChild(ggroup);
           ggroup.appendChild(yah);
           ggroup.appendChild(facing);
           ggroup.appendChild(circle);
          }
        } else {
          var here = document.getElementById('youarehere'); // nice clean way to remove them
          here && here.parentNode.removeChild(here);
          var fac = document.getElementById('facing'); // nice clean way to remove them
          fac && fac.parentNode.removeChild(fac);
        }
    }

    componentDidMount () {
        // Kick off API calls to fetch available maps and load maps

        let is404 = false;

        APIService.GetAvailableMaps()
            .then((result) => {
                // Inititalize maps in services

                if (result.status === 404) {
                  // mock of mapmeta.... https://wayfinding-task-service.dev.ad.l11.com/wayfinding/v1/assets/metadata
                  result = [{"tp":"MapMetadata","id":"0341a47a-b87b-4fcd-b4c4-b2cce43a5355","__etag":"-1","assetRef":"f02b958c-af27-471a-b738-85f71700ee0b","url":"url","structure":"AmericanDream","level":3,"desc":"Map of floor 3","markerScale":1.0,"autoZoomMargin":1.0,"positionGeoUpper":{"x":6,"y":210,"z":14}},{"tp":"MapMetadata","id":"d3565e64-8d25-4861-a66b-a5010ea934be","__etag":"-1","assetRef":"f606ec1c-8b9e-4aca-a4c0-dd8cb0167444","url":"url","structure":"AmericanDream","level":2,"desc":"Map of floor 2","markerScale":1.0,"autoZoomMargin":1.0,"positionGeoUpper":{"x":6,"y":210,"z":14}},{"tp":"MapMetadata","id":"b3fbe0fa-af0b-4b32-b538-e662c28721c4","__etag":"-1","assetRef":"2322ba94-275f-449c-88e3-e70c1e8cfd83","url":"url","structure":"AmericanDream","level":1,"desc":"Map of floor 1","markerScale":1.0,"autoZoomMargin":1.0,"positionGeoUpper":{"x":6,"y":210,"z":14}}];
                  is404 = true;
                }



                result.forEach(mapMeta => {
                    if (!is404)  {
                      // Load SVG data for service parsing
                      SVGService.loadSVGDataByName(mapMeta, (loadedSVG) => {
                          // Initialize routing
                          // FIXME... routing is not up so skip it
                          //RoutingService.InitializeRouting(loadedSVG);

                          // Initialize POIs
                          // FIXME: Turned off until POI data format is decided
                          // JJR NOTE: looks like this was going by parsing the map for POI Ids embedded in SVG. which we can work with but won't match too much yet.

                          POIService.InitializePOIs(mapMeta, SVGService.getSVGPointsOfInterest(loadedSVG));

                          // Set origin
                          // TODO: Don't hardcode this - requires location service integration
                          //this.props.setOrigin( RoutingService.GetWaypointByLocation("Level11.Floor20.4575") );

                          // Notify store of loaded map

                          const availableMaps = this.props.availableMaps.slice(0);
                          availableMaps.push(mapMeta);
                          this.props.setAvailableMaps(availableMaps);

                          var that = this;
                          // maybe put this inside map load so it happens nested inside it.
                          APIService.GetAOIs()
                              .then((result) => {
                                // Something simpler, like take result and put it in state,
                                // or could use forEach to make dictionary out of this array




                                that.props.setAois(result);
                                that.setState( {aoisL: result} );
                                // result.forEach(aoi => {
                                //     console.log("AOI Data:", aoi);
                                //     var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
                                //     circle.setAttribute('id', 'aoi.' + aoi.location);
                                //     circle.setAttributeNS(null, 'cx', aoi.position.x);
                                //     circle.setAttributeNS(null, 'cy', aoi.position.y);
                                //     circle.setAttributeNS(null, 'r', 5);
                                //     circle.setAttributeNS(null, 'style', 'fill: #00AAFF; stroke: black; stroke-width: 1px;' );
                                //
                                //     const loc = aoi.location.split(".");
                                //     const mapName = loc[0] + "." + loc[1];
                                //     // const mapName = that.props.availableMaps[0].structure + '.Floor' + that.props.availableMaps[0].level
                                //     const mapSVG = document.getElementById(mapName);
                                //     if (mapSVG) {
                                //       const drawTarget = mapSVG.getElementById("Impossible");
                                //       drawTarget.appendChild(circle);
                                //     }
                                // });

                          });

                          // maybe put this inside map load so it happens nested inside it.
                          APIService.GetPOIs()
                              .then((result) => {

                                that.props.setPois(result);
                                // Something simpler, like take result and put it in state,
                                // or could use forEach to make dictionary out of this array
                                  // result.forEach(poi => {
                                  //     if (!is404)  {
                                  //
                                  //
                                  //
                                  //       // Load SVG data for service parsing
                                  //       // SVGService.loadSVGDataByName(mapMeta, (loadedSVG) => {
                                  //       //     const availableMaps = this.props.availableMaps.slice(0);
                                  //       //     availableMaps.push(mapMeta);
                                  //       //     this.props.setAvailableMaps(availableMaps);
                                  //       // });
                                  //     } else {
                                  //
                                  //     }
                                  // });

                          });
                      });
                    } else {
                      SVGService.loadMockSVGDataByName(mapMeta, (loadedSVG) => {
                          const availableMaps = this.props.availableMaps.slice(0);
                          availableMaps.push(mapMeta);
                          this.props.setAvailableMaps(availableMaps);
                      });
                    }
                });



                this.setState({
                    loading: false,
                });
            });

        // Set up location event pinging
        //window.setInterval(() => {
            // APIService.GetAllUserLocations()
            //     .then((result) => {
            //         // Quick function to determine if time is older than an hour, from
            //         //  https://stackoverflow.com/questions/9224773/js-check-if-date-is-less-than-1-hour-ago
            //         const lessThanOneHourAgo = (date) => {
            //             const HOUR = 1000 * 60 * 60;
            //             let anHourAgo = Date.now() - HOUR;
            //
            //             return date > anHourAgo;
            //         }
            //
            //         // Update state with result items
            //         const events = Object.values(result);
            //         for (var i = 0; i < events.length; i++) {
            //             const event = events[i];
            //
            //             // Ignore old events
            //             if (!lessThanOneHourAgo(new Date( event.time ))) continue;
            //
            //             this.props.setLocatable(
            //                 new Locatable(
            //                     `${event.major}:${event.minor} - ${event.uuid}`,
            //                     new Position(
            //                         event.position.x,
            //                         event.position.y,
            //                         event.position.z,
            //                     )
            //                 )
            //             );
            //         }
            //     });
        //}, 1000);

        // Set up native communication layer
        APIService.GetConfig()
            .then((result) => {
                // Configure Native communication layer
                NativeService.SetNativeConfig(result);

                // Hook Native communication to state updates
                NativeService.Subscribe('locatable', (locatableData) => {
                    // This locatable format is an understanding between the native application
                    // and web view.  TODO: Document it somewhere.
                    this.props.setLocatable(
                        new Locatable(
                            locatableData[0],
                            new Position(
                                locatableData[1],
                                locatableData[2],
                                locatableData[3],
                            )
                        )
                    );
                });
            });

        // Set up iframe communication to display locatable
        // Based on https://gist.github.com/pbojinov/8965299
        function bindEvent(element, eventName, eventHandler) {
            if (element.addEventListener) {
                element.addEventListener(eventName, eventHandler, false);
            } else if (element.attachEvent) {
                element.attachEvent('on' + eventName, eventHandler);
            }
        }
        // Listen to messages from parent window
        bindEvent(window, 'message', (e) => {
            console.log("child frame:", e.data);
            if (e.data) {
                switch (e.data) {
                   case "CmdZoomIn":
                        this.toggleYou();
                        this.setState( {showRoute: !this.state.showRoute } );
                        if ( this.state.showRoute ) {

                              var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
                              path.setAttribute('id', 'route.1');
                              path.setAttribute('class', 'routePath');
                              path.setAttributeNS(null, 'd', 'M 300,400 L 300,355 L 307,345 L 300,335 L 300,325  Q 340,310 323,270 L 367,230 L 376,235');
                              path.setAttributeNS(null, 'style', 'fill: none; stroke: #558DCA; stroke-width: 7px; stroke-dasharray: 10; stroke-dashoffset: 1000; animation: dash 20s linear;' );

                              const mapName = "AmericanDream.Floor1";
                              const mapSVG = document.getElementById(mapName);

                              var destinationPoint = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
                              destinationPoint.setAttribute('id', 'route.1.destinationPoint');
                              destinationPoint.setAttribute('class', 'routePath');
                              destinationPoint.setAttributeNS(null, 'cx', 376);
                              destinationPoint.setAttributeNS(null, 'cy', 235);

                              //add the final one in the area.
                              if (mapSVG) {
                                const drawTarget = mapSVG.getElementById("Impossible");
                                drawTarget.appendChild(path);
                                drawTarget.appendChild(destinationPoint);
                              }
                              this.setState({ markerVisible: true, markerPOI: 'route.1.destinationPoint' });
                        } else {
                          var wayps = document.querySelectorAll('.routePath'); // nice clean way to remove them
                          wayps.forEach(function(wayp) {
                            wayp.parentNode.removeChild(wayp);
                          });
                           this.setState({ markerVisible: false });
                         }
                   break;
                   case "CmdZoomOut":
                        this.setState( {showWaypoints: !this.state.showWaypoints } );
                        if ( this.state.showWaypoints ) {
                           this.state.aoisL.forEach(aoi => {
                               console.log("AOI Data:", aoi);
                               var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
                               circle.setAttribute('id', 'aoi.' + aoi.location);
                               circle.setAttribute('class', 'aoiWaypoint');
                               circle.setAttributeNS(null, 'cx', aoi.position.x);
                               circle.setAttributeNS(null, 'cy', aoi.position.y);
                               circle.setAttributeNS(null, 'r', 5);
                               circle.setAttributeNS(null, 'style', 'fill: #00AAFF; stroke: black; stroke-width: 1px;' );

                               const loc = aoi.location.split(".");
                               const mapName = loc[0] + "." + loc[1];
                               // const mapName = that.props.availableMaps[0].structure + '.Floor' + that.props.availableMaps[0].level
                               const mapSVG = document.getElementById(mapName);

                               //add the final one in the area.
                               if (mapSVG) {
                                 const drawTarget = mapSVG.getElementById("Impossible");
                                 drawTarget.appendChild(circle);
                               }
                           });
                       } else {
                           var wayps = document.querySelectorAll('.aoiWaypoint'); // nice clean way to remove them
                           wayps.forEach(function(wayp) {
                             wayp.parentNode.removeChild(wayp);
                           });
                       }
                   break;
                    case "CmdFloor1":
                            this.props.availableMaps.forEach( map => {
                                if (map.level == 1) {
                                this.props.setSelectedMap(map);
                                }
                            } );
                    break;
                    case "CmdFloor2":
                            this.props.availableMaps.forEach( map => {
                                if (map.level == 2) {
                                this.props.setSelectedMap(map);
                                }
                            } );
                    break;
                    case "CmdFloor3":
                            this.props.availableMaps.forEach( map => {
                                if (map.level == 3) {
                                this.props.setSelectedMap(map);
                                }
                            } );
                    break;
                    case "CmdFloor4":
                            this.props.availableMaps.forEach( map => {
                                if (map.level == 4) {
                                this.props.setSelectedMap(map);
                                }
                            } );
                    break;
                    case "CmdFloor5":
                            this.props.availableMaps.forEach( map => {
                                if (map.level == 5) {
                                this.props.setSelectedMap(map);
                                }
                            } );
                    break;
                   case "CmdRESTROOMS":
                        this.setState( {showRestrooms: !this.state.showRestrooms } );
                       console.log("Restroom Display:");
                       if ( this.state.showRestrooms ) {
                            //
                            for ( var fdx = 1; fdx < 4; fdx++ ) {
                                var floorId = "AmericanDream.Floor" + fdx;
                                var curFloor = document.getElementById(floorId);
                                var findRestrooms = curFloor.querySelectorAll("[id^='Restroom']");

                                findRestrooms.forEach( function( rr ) {
                                    var node = rr.getBBox();
                                    var xc = node.x + node.width/2;
                                    var yc = node.y + node.height/2;
                                    var rgroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
                                    rgroup.setAttribute('class', 'restroomPOIg');
                                    rgroup.setAttributeNS(null, 'transform', "translate(" + xc + " " + yc + ")");

                                    var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
                                    circle.setAttribute('id', 'restroomDot.' + node.x + '-' + node.y);
                                    circle.setAttribute('class', 'restroomPOI');

                                    // circle.setAttributeNS(null, 'cx', xc);
                                    // circle.setAttributeNS(null, 'cy', yc);
                                    circle.setAttributeNS(null, 'r', 10);
                                    circle.setAttributeNS(null, 'style', 'fill: #333333; stroke: #333333; stroke-width: 1px;' );

                                    var icon = document.createElementNS('http://www.w3.org/2000/svg', 'path');
                                    icon.setAttribute('id', 'restroom.' + node.x + '-' + node.y);
                                    icon.setAttribute('class', 'restroomPOI');

                                    icon.setAttributeNS(null, 'style', 'fill: #FFFFFF;' );
                                    icon.setAttributeNS(null, 'transform', "translate(-8 -8) scale(0.7 0.7)");
                                    icon.setAttributeNS(null, 'd', 'M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63C18.18 7.55 17.42 7 16.56 7h-.12c-.86 0-1.63.55-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z');

                                    const mapSVG = document.getElementById(floorId);

                                    if (mapSVG) {
                                      // if find another circle of class aoiWaypoint within ? x and y of this one then delete that one.
                                      var wayps = mapSVG.querySelectorAll('.restroomPOIg'); // nice clean way to remove them
                                      wayps.forEach(function(wayp) {

                                            if (wayp.transform) {
                                              var fx = wayp.transform.baseVal[0].matrix.e;
                                              var fy = wayp.transform.baseVal[0].matrix.f;
                                              if ( (fx < xc + 40 && fx> xc - 40) && (fy < yc + 40 && fy > yc - 40) ) {
                                                wayp.parentNode.removeChild(wayp);
                                              }
                                            }
                                      });

                                      const drawTarget = mapSVG.getElementById("Impossible");
                                      drawTarget.appendChild(rgroup);
                                      rgroup.appendChild(circle);
                                      rgroup.appendChild(icon);
                                    }
                                });
                            }
                        } else {
                            var poorooms = document.querySelectorAll('.restroomPOI'); // nice clean way to remove them
                            poorooms.forEach(function(pooroom) {
                              pooroom.parentNode.removeChild(pooroom);
                            });
                        }
                   break;
                   case "CmdELEVATOR":
                        this.setState( {showElevators: !this.state.showElevators } );
                       console.log("Elevators Display:");
                       if ( this.state.showElevators ) {
                            //
                            for ( var fdx = 1; fdx < 6; fdx++ ) {
                                var floorId = "AmericanDream.Floor" + fdx;
                                var curFloor = document.getElementById(floorId);
                                var groupElevators = curFloor.getElementById("Elevators");
                                if (!groupElevators) { return; }
                                var findElevators = groupElevators.querySelectorAll("g");

                                findElevators.forEach( function( rr ) {
                                    var node = rr.getBBox();
                                    var xc = node.x + node.width/2;
                                    var yc = node.y + node.height/2;
                                    var rgroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
                                    rgroup.setAttribute('class', 'elevatorPOIg');
                                    rgroup.setAttributeNS(null, 'transform', "translate(" + xc + " " + yc + ")");

                                    var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
                                    circle.setAttribute('id', 'elevatorDot.' + node.x + '-' + node.y);
                                    circle.setAttribute('class', 'elevatorPOI');

                                    circle.setAttributeNS(null, 'r', 10);
                                    circle.setAttributeNS(null, 'style', 'fill: #FFAACC; stroke: #333333; stroke-width: 1px;' );

                                    const mapSVG = document.getElementById(floorId);

                                    if (mapSVG) {
                                      // if find another circle of class aoiWaypoint within ? x and y of this one then delete that one.
                                      var wayps = mapSVG.querySelectorAll('.elevatorPOIg'); // nice clean way to remove them
                                      wayps.forEach(function(wayp) {

                                            if (wayp.transform) {
                                              var fx = wayp.transform.baseVal[0].matrix.e;
                                              var fy = wayp.transform.baseVal[0].matrix.f;
                                              if ( (fx < xc + 40 && fx> xc - 40) && (fy < yc + 40 && fy > yc - 40) ) {
                                                wayp.parentNode.removeChild(wayp);
                                              }
                                            }
                                      });

                                      const drawTarget = mapSVG.getElementById("Impossible");
                                      drawTarget.appendChild(rgroup);
                                      rgroup.appendChild(circle);
                                    }
                                });
                            }
                        } else {
                            var poorooms = document.querySelectorAll('.elevatorPOI'); // nice clean way to remove them
                            poorooms.forEach(function(pooroom) {
                              pooroom.parentNode.removeChild(pooroom);
                            });
                        }
                   break;
                   case "CmdESCALATOR":
                        this.setState( {showEscalators: !this.state.showEscalators } );
                       console.log("Escalators Display:");
                       if ( this.state.showEscalators ) {
                            //
                            for ( var fdx = 1; fdx < 6; fdx++ ) {
                                var floorId = "AmericanDream.Floor" + fdx;
                                var curFloor = document.getElementById(floorId);
                                var groupEscalators = curFloor.getElementById("Escalators");
                                if (!groupEscalators) { return; }
                                var findEscalators = groupEscalators.querySelectorAll("g");

                                findEscalators.forEach( function( rr ) {
                                    var node = rr.getBBox();
                                    var xc = node.x + node.width/2;
                                    var yc = node.y + node.height/2;
                                    var rgroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
                                    rgroup.setAttribute('class', 'escalatorPOIg');
                                    rgroup.setAttributeNS(null, 'transform', "translate(" + xc + " " + yc + ")");

                                    var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
                                    circle.setAttribute('id', 'escalatorDot.' + node.x + '-' + node.y);
                                    circle.setAttribute('class', 'escalatorPOI');

                                    circle.setAttributeNS(null, 'r', 10);
                                    circle.setAttributeNS(null, 'style', 'fill: #CCAAFF; stroke: #333333; stroke-width: 1px;' );

                                    const mapSVG = document.getElementById(floorId);

                                    if (mapSVG) {
                                      // if find another circle of class aoiWaypoint within ? x and y of this one then delete that one.
                                      var wayps = mapSVG.querySelectorAll('.escalatorPOIg'); // nice clean way to remove them
                                      wayps.forEach(function(wayp) {

                                            if (wayp.transform) {
                                              var fx = wayp.transform.baseVal[0].matrix.e;
                                              var fy = wayp.transform.baseVal[0].matrix.f;
                                              if ( (fx < xc + 40 && fx> xc - 40) && (fy < yc + 40 && fy > yc - 40) ) {
                                                wayp.parentNode.removeChild(wayp);
                                              }
                                            }
                                      });

                                      const drawTarget = mapSVG.getElementById("Impossible");
                                      drawTarget.appendChild(rgroup);
                                      rgroup.appendChild(circle);
                                    }
                                });
                            }
                        } else {
                            var poorooms = document.querySelectorAll('.escalatorPOI'); // nice clean way to remove them
                            poorooms.forEach(function(pooroom) {
                              pooroom.parentNode.removeChild(pooroom);
                            });
                        }
                   break;
                   case "CmdSTAIRS":
                        this.setState( {showStairs: !this.state.showStairs } );
                       console.log("Stairs Display:");
                       if ( this.state.showStairs ) {
                            //
                            for ( var fdx = 1; fdx < 6; fdx++ ) {
                                var floorId = "AmericanDream.Floor" + fdx;
                                var curFloor = document.getElementById(floorId);
                                var groupStairs = curFloor.getElementById("Stairs");
                                if (!groupStairs) { return; }
                                var findStairs = groupStairs.querySelectorAll("g");

                                findStairs.forEach( function( rr ) {
                                    var node = rr.getBBox();
                                    var xc = node.x + node.width/2;
                                    var yc = node.y + node.height/2;
                                    var rgroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
                                    rgroup.setAttribute('class', 'stairPOIg');
                                    rgroup.setAttributeNS(null, 'transform', "translate(" + xc + " " + yc + ")");

                                    var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
                                    circle.setAttribute('id', 'stairDot.' + node.x + '-' + node.y);
                                    circle.setAttribute('class', 'stairPOI');

                                    circle.setAttributeNS(null, 'r', 10);
                                    circle.setAttributeNS(null, 'style', 'fill: #AAFFCC; stroke: #333333; stroke-width: 1px;' );

                                    const mapSVG = document.getElementById(floorId);

                                    if (mapSVG) {
                                      // if find another circle of class aoiWaypoint within ? x and y of this one then delete that one.
                                      var wayps = mapSVG.querySelectorAll('.stairPOIg'); // nice clean way to remove them
                                      wayps.forEach(function(wayp) {

                                            if (wayp.transform) {
                                              var fx = wayp.transform.baseVal[0].matrix.e;
                                              var fy = wayp.transform.baseVal[0].matrix.f;
                                              if ( (fx < xc + 40 && fx> xc - 40) && (fy < yc + 40 && fy > yc - 40) ) {
                                                wayp.parentNode.removeChild(wayp);
                                              }
                                            }
                                      });

                                      const drawTarget = mapSVG.getElementById("Impossible");
                                      drawTarget.appendChild(rgroup);
                                      rgroup.appendChild(circle);
                                    }
                                });
                            }
                        } else {
                            var poorooms = document.querySelectorAll('.stairPOI'); // nice clean way to remove them
                            poorooms.forEach(function(pooroom) {
                              pooroom.parentNode.removeChild(pooroom);
                            });
                        }
                   break;
                   case "CmdATM":
                        this.setState( {showAtm: !this.state.showAtm } );
                       console.log("ATM Display:");
                       if ( this.state.showAtm ) {
                            //
                            for ( var fdx = 1; fdx < 4; fdx++ ) {
                                var floorId = "AmericanDream.Floor" + fdx;
                                var curFloor = document.getElementById(floorId);
                                var findAtms = curFloor.querySelectorAll("[id^='ATM']");

                                findAtms.forEach( function( rr ) {
                                    var node = rr.getBBox();
                                    var xc = node.x + node.width/2;
                                    var yc = node.y + node.height/2;
                                    var rgroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
                                    rgroup.setAttribute('class', 'AtmPOIg');
                                    rgroup.setAttributeNS(null, 'transform', "translate(" + xc + " " + yc + ")");

                                    var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
                                    circle.setAttribute('id', 'AtmDot.' + node.x + '-' + node.y);
                                    circle.setAttribute('class', 'AtmPOI');

                                    // circle.setAttributeNS(null, 'cx', xc);
                                    // circle.setAttributeNS(null, 'cy', yc);
                                    circle.setAttributeNS(null, 'r', 10);
                                    circle.setAttributeNS(null, 'style', 'fill: #EEBB00; stroke: #333333; stroke-width: 1px;' );

                                    var icon = document.createElementNS('http://www.w3.org/2000/svg', 'path');
                                    icon.setAttribute('id', 'Atm.' + node.x + '-' + node.y);
                                    icon.setAttribute('class', 'AtmPOI');

                                    icon.setAttributeNS(null, 'style', 'fill: #FFFFFF;' );
                                    icon.setAttributeNS(null, 'transform', "translate(-8 -8) scale(0.7 0.7)");
                                    icon.setAttributeNS(null, 'd', 'M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z');

                                    const mapSVG = document.getElementById(floorId);

                                    if (mapSVG) {
                                      // if find another circle of class aoiWaypoint within ? x and y of this one then delete that one.
                                      var wayps = mapSVG.querySelectorAll('.AtmPOIg'); // nice clean way to remove them
                                      wayps.forEach(function(wayp) {

                                            if (wayp.transform) {
                                              var fx = wayp.transform.baseVal[0].matrix.e;
                                              var fy = wayp.transform.baseVal[0].matrix.f;
                                              if ( (fx < xc + 40 && fx> xc - 40) && (fy < yc + 40 && fy > yc - 40) ) {
                                                wayp.parentNode.removeChild(wayp);
                                              }
                                            }
                                      });

                                      const drawTarget = mapSVG.getElementById("Impossible");
                                      drawTarget.appendChild(rgroup);
                                      rgroup.appendChild(circle);
                                      rgroup.appendChild(icon);
                                    }
                                });
                            }
                        } else {
                            var poorooms = document.querySelectorAll('.AtmPOI'); // nice clean way to remove them
                            poorooms.forEach(function(pooroom) {
                              pooroom.parentNode.removeChild(pooroom);
                            });
                        }
                   break;
                   case "CmdYouAreHere":
                          this.toggleYou();
                   break;
                   case "CmdEventsList":
                       console.log("Event List Display:");
                       this.setState( { showEvents: !this.state.showEvents } );
                       if ( this.state.showEvents ) {
                           for ( var rdx = 0; rdx < 10; rdx++ ) {
                               var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
                               circle.setAttribute('id', 'eventlist.' + rdx);
                               circle.setAttribute('class', 'eventPOI');
                               circle.setAttributeNS(null, 'cx', 240 + Math.random() * 100);
                               circle.setAttributeNS(null, 'cy', 290 + Math.random() * 300);
                               circle.setAttributeNS(null, 'r', 6);
                               circle.setAttributeNS(null, 'style', 'fill: #33FF55; stroke: black; stroke-width: 1px;' );
                               //
                               // const loc = aoi.location.split(".");
                               const mapName = "AmericanDream.Floor1";
                               // const mapName = that.props.availableMaps[0].structure + '.Floor' + that.props.availableMaps[0].level
                               const mapSVG = document.getElementById(mapName);
                               if (mapSVG) {
                                 const drawTarget = mapSVG.getElementById("Impossible");
                                 drawTarget.appendChild(circle);
                               }
                            }
                        } else {
                            var evs = document.querySelectorAll('.eventPOI'); // nice clean way to remove them

                            evs.forEach(function(ev) {
                              ev.parentNode.removeChild(ev);
                            });
                        }
                   break;
                }

                var matchingWaypoint = RoutingService.GetWaypointByLocation(e.data);

                if (matchingWaypoint) {
                    // Set to ad locatable on map
                    console.log("ADDING LOCATABLE " + matchingWaypoint.id + " AT " + matchingWaypoint.position.X, matchingWaypoint.position.Y, matchingWaypoint.position.Z);
                    this.props.setLocatable(
                        new Locatable(
                            matchingWaypoint.id,
                            matchingWaypoint.position,
                        )
                    );
                }
            }
        });
    }

    getErrorComponent () {
        if (this.props.error == null) return null;

        return (
            <div className="modal is-active">
                <div className="modal-background" onClick={() => this.props.setError(null)}></div>
                <div className="modal-content">
                    <article className="message is-danger">
                        <div className="message-header">
                            <p>Error</p>
                            <button className="delete" aria-label="delete" onClick={() => this.props.setError(null)}></button>
                        </div>
                        <div className="message-body">
                            { this.props.error }
                        </div>
                    </article>
                </div>
            </div>
        );
    }
}

App.propTypes = {
  activeRenderer: PropTypes.string.isRequired,
  renderers: PropTypes.arrayOf(PropTypes.string).isRequired,
  setRenderer: PropTypes.func.isRequired,
  availableMaps: PropTypes.arrayOf(PropTypes.object),
  setAvailableMaps: PropTypes.func.isRequired,
  setSelectedMap: PropTypes.func.isRequired,
  aoisL: PropTypes.arrayOf(PropTypes.object),
  aois: PropTypes.arrayOf(PropTypes.object),
  pois: PropTypes.arrayOf(PropTypes.object),
  setOrigin: PropTypes.func.isRequired,
  setLocatable: PropTypes.func.isRequired,
  removeLocatable: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
  error: PropTypes.string,
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js